import dayjs from 'dayjs';

import { apiStatusError, fetchError } from 'FRONTEND/utils/errors';
import { getApiPatientFollowUpPath } from 'FRONTEND/utils/routes';

const formatFollowUpConsultation = ([consultationId, rawConsultation]) => {
  return {
    ...rawConsultation,
    id: consultationId,
    vitals: Object.entries(rawConsultation.vitals).map(([label, vital]) => ({
      value: vital[0],
      unit: vital[1],
      label,
      id: label, // TODO: not sure it's unique
    })),
  };
};

export async function getFollowUpData({ patientId, startDate, endDate }) {
  const params = new URLSearchParams();
  if (startDate) {
    params.append('start_date', dayjs(startDate).format('YYYY-MM-DD'));
  }
  if (endDate) {
    params.append('end_date', dayjs(endDate).format('YYYY-MM-DD'));
  }
  try {
    const response = await fetch(`${getApiPatientFollowUpPath(patientId)}?${params}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then((data) => {
      apiStatusError({ response: data });
      return data.json();
    });

    return {
      consultations: Object.entries(response.consultations).map(formatFollowUpConsultation),
      data: response.data,
    };
  } catch (error) {
    throw fetchError({ error });
  }
}
